import gsap from "gsap";
import { animateWords, animateObserver, maskInParallax, fadeIn } from "../../../js/animations/animations";
import { isAuthor, isMobile } from "../../../js/utils";

(() => {
  const BRHBannerShowcase = () => {
    const init = () => {
      //== Animations
      if (!isMobile() && !isAuthor()) {
        const bannerShowcase = document.querySelectorAll(".brh-banner-showcase");
        if (bannerShowcase.length > 0) {
          bannerShowcase.forEach((element) => {
            const timeline = gsap.timeline({
              scrollTrigger: {
                trigger: element,
                toggleActions: "reverse restart none none",
                start: "top 90%",
                end: "50% center",
                scrub: true,
                // markers: true,
              },
            });
            timeline.add(maskInParallax({ classElement: element }), 0);

            const appearances = gsap.timeline();

            const defaultTitles = element.querySelectorAll(`.brh-banner-showcase__title`);
            defaultTitles.length > 0 && appearances.add(animateWords({ classElement: defaultTitles }), 0);

            const decorativeTitles = element.querySelectorAll(`.brh-banner-showcase__decorativeTitle`);
            decorativeTitles.length > 0 && appearances.add(fadeIn({ classElement: decorativeTitles, duration: 2 }), 0);

            const paragraph = element.querySelectorAll(".js-banner-showcase-fadeIn p");
            paragraph.length > 0 && appearances.add(fadeIn({ classElement: ".js-banner-showcase-fadeIn p", duration: 3 }), 0);

            // const bannerShowcaseMask = element.querySelector(".js-banner-showcase-mask");
            // bannerShowcaseMask && appearances.add(maskIn({ classElement: bannerShowcaseMask }), 0);

            appearances.pause();

            animateObserver({ elementToObserve: element, animation: () => appearances, threshold: 0 });
          });
        }
      }
    };

    init();
  };

  document.addEventListener("DOMContentLoaded", BRHBannerShowcase);
})();
